/**
 * GET /api/admin/communications — communication outbox + templates.
 *
 * Backend uses `id` for the row identifier (not `communicationId`).
 * Used by useCommunications, useCommunicationTemplates.
 */
import { z } from 'zod';

export const CommunicationSchema = z.looseObject({
  id: z.string().min(1),
  subject: z.string().nullable().optional(),
  body: z.string().nullable().optional(),
  status: z.string().optional(),
  scheduledFor: z.string().nullable().optional(),
  sentAt: z.string().nullable().optional(),
  recipientCount: z.number().optional(),
  createdAt: z.string().optional(),
  createdBy: z.string().nullable().optional(),
  metadata: z.record(z.string(), z.unknown()).optional(),
});

export type Communication = z.infer<typeof CommunicationSchema>;

export const CommunicationsListResponseSchema = z.looseObject({
  communications: z.array(CommunicationSchema),
  nextCursor: z.string().nullable().optional(),
});

export type CommunicationsListResponse = z.infer<
  typeof CommunicationsListResponseSchema
>;

export const CommunicationTemplateSchema = z.looseObject({
  id: z.string().min(1).optional(),
  templateId: z.string().min(1).optional(),
  name: z.string().min(1).optional(),
  subject: z.string().optional(),
  body: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  metadata: z.record(z.string(), z.unknown()).optional(),
});

export type CommunicationTemplate = z.infer<typeof CommunicationTemplateSchema>;

export const CommunicationTemplatesListResponseSchema = z.looseObject({
  templates: z.array(CommunicationTemplateSchema),
});

export type CommunicationTemplatesListResponse = z.infer<
  typeof CommunicationTemplatesListResponseSchema
>;
